<script setup lang="ts">
import type { SaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
});

// COMPOSABLES
const { tt } = useTypedI18n();
const { title, classes } = useSaleTitle(() => sale);
</script>

<template>
    <section class="flex flex-col gap-y-2">
        <p v-if="classes" class="text-xs md:text-lg">
            {{ classes }}
        </p>

        <h1 class="text-highlighted text-2xl font-bold md:text-4xl">
            {{ title }}
        </h1>

        <p class="text-xs md:text-sm">
            {{ tt('sdp.incrementIdLabel') }}: <span class="select-all">{{ sale.incrementId }}</span>
        </p>
    </section>
</template>
